import { Suspense, useEffect, lazy } from 'react'; //useState
import { Route } from 'react-router-dom'; //, Routes
import PrivateRoute from './components/PrivateRoute';
import { useDispatch } from 'react-redux';
import { LoadUser } from './application/middlewares/auth';

import { MantineProvider, DirectionProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import CustomRoutes from './components/CustomRouter';
import ErrorBoundary from './components/ErrorBoundary';
import { LoadingOverlay } from '@mantine/core';

// Containers
const Layout = lazy(() => import('./Layout'));

// Pages
const Login = lazy(() => import('./pages/login'));
// Partner portal — self-contained, outside the admin auth gate.
const PartnerPortal = lazy(() => import('./partner-portal/PartnerPortal'));

function App() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(LoadUser() as any); //eslint-disable-next-line
    }, []);
    return (
        <DirectionProvider>
            <MantineProvider withGlobalClasses withCssVariables>
                <Notifications />
                {/* The outer net: the Layout, login and partner chunks load here, and
                    Layout's own boundary cannot catch its own chunk failing. Pages
                    are caught inside Layout, so the header survives a page error. */}
                <ErrorBoundary>
                    <Suspense
                        fallback={<LoadingOverlay visible zIndex={1000} overlayProps={{ radius: 'sm', blur: 2 }} />}
                    >
                        <CustomRoutes>
                            {/* <Routes> */}
                            <Route path="login" element={<Login />} />
                            <Route path="partner" element={<PartnerPortal />} />
                            <Route
                                path="/*"
                                element={
                                    <PrivateRoute>
                                        <Layout />
                                    </PrivateRoute>
                                }
                            />
                            <Route path="*" element={<div>Not found</div>} />
                            {/* </Routes> */}
                        </CustomRoutes>
                    </Suspense>
                </ErrorBoundary>
            </MantineProvider>
        </DirectionProvider>
    );
}

export default App;
